import { Icon } from "@thetreep/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useExchangeContext } from "./context";
import JourneyDisplay from "../cart/journey/Journey";

export function ExchangeHeader() {
  // deps
  const { t } = useTranslation();

  // params
  const { travel, journey } = useExchangeContext();

  // state
  const [isOpen, setIsOpen] = useState(false);

  if (!travel || !journey) return;

  return (
    <div className="w-full fixed z-[99] top-[230px] left-0 right-0 lg:static rounded-lg md:top-[290px] bg-white lg:self-start shadow-[0px_0px_48px_0px_#00000029] lg:shadow-none">
      <h2
        onClick={() => setIsOpen(!isOpen)}
        className="title pointer  text-cnam-blue font-jakarta text-[16px] flex justify-between items-center py-4 px-6 border-b border-[#D0D9E9] 
       lg:pointer-events-none lg:hidden"
      >
        {t("booking.exchange.tripToExchange")}
        <div className={`lg:hidden ${isOpen ? "block rotate-180" : ""}`}>
          <Icon src="down_line" size={24} />
        </div>
      </h2>

      <div
        className={`  ${
          isOpen ? "block" : "hidden"
        }  bg-white absolute w-full lg:static lg:block z-[50] border-b border-[#D0D9E9] lg:border-none rounded-lg`}
      >
        <div className=" w-full bg-neutral-50 p-8 rounded-md flex flex-col gap-10">
          <div className="hidden lg:block text-[20px] font-jakarta font-bold">
            {t("booking.exchange.tripToExchange")} :{" "}
            {journey.route?.origin?.name} → {journey.route?.destination?.name}
          </div>
          <div className="flex flex-col gap-6 lg:flex-row">
            <JourneyDisplay journey={journey} travel={travel} />
          </div>
        </div>
      </div>
    </div>
  );
}
